
import XDialog from 'vux/src/components/x-dialog/index.vue'


export default {
components: {
XDialog
},
props: {},
data() {
return {
loadingShow: true,
homeShow: false,
showToast: false,
loadingNum: -1,
fbhToast: false,
loadingIcon: [
{
icon: "http://cdn.qianhai12315.com/m8/static/img/dh.png",
type: 0
},
{
icon: "http://cdn.qianhai12315.com/m8/static/img/dh.png",
type: 0
},
{
icon: "http://cdn.qianhai12315.com/m8/static/img/dh.png",
type: 0
}
]
};
},
watch: {

},
computed: {

},
methods: {

loading() {
setTimeout(() => {
this.loadingShow = false;
this.homeShow = true;
clearTimeout(this.dsq);
}, 1500);
},
loadingAnim() {
this.dsq = setInterval(() => {
this.loadingNum++;
if (this.loadingNum > 2) {
this.loadingNum = -1;
this.loadingIcon[0].type = 0;
this.loadingIcon[1].type = 0;
this.loadingIcon[2].type = 0;
} else {
console.log(1);
this.loadingIcon[this.loadingNum].type = 1;
}
}, 300);
},
upload() {
this.$router.push({ name: "upload" });
}
},
created() {

console.log("index渲染前");
},
mounted() {

console.log("index渲染完成调用");
this.loadingAnim();
this.loading();

var text = [
`${this.local.nickname}本年度拍过的最烂照片，真是惊呆了！`,
"魅族Note8 国民拍照手机，10月25日拯救你的烂照片。",
`${this.local.nickname}晒了他半年度拍过的最烂照片，大家快来强势围观！`,
`论拍烂照片，${this.local.nickname}至今还没怕过谁，不信？那你点进来比比。`,
"照片拍不好，是你没有用魅族 Note8 国民拍照手机。"
];
var _desc = Math.floor(Math.random() * text.length);

console.log("微信分享");
var appid = this.Global.appid;
var wechat = new Wechat(appid);

this.$vux.loading.hide();
wechat.config({
debug: false,
jsApiList: [
"checkJsApi",
"onMenuShareTimeline",
"onMenuShareAppMessage",
"onMenuShareQQ",
"onMenuShareWeibo"
]
});
let _name = encodeURIComponent(this.local.nickname);

var share_url =
location.href.split("#")[0] +
"#" +
this.$route.path +
"?state=1&id=" +
this.$route.query.id;

console.log("参数解析");

console.log(
location.href.split("#")[0] + "#" + location.href.split("#")[1]
);
console.log("参数解析" + share_url);

var title = "10.25 国民拍照手机魅族 Note8 新品发布会";
var desc = text[_desc];
wechat.shareFriend(
{
appmessageTitle: title,
appmessageDesc: desc,
link: share_url,
imgUrl: "https://customer-cdn.tuzhanai.com/xfxb/static/J2qmSlfQ.jpg"
},
() => {

console.log("分享成功");
let data = {
openid: this.local.openid
};
this.save(data);
},
function() {
console.log("cancel");
}
);

wechat.shareTimeline(
{
timelineTitle: desc,
link: share_url,
imgUrl: "https://customer-cdn.tuzhanai.com/xfxb/static/J2qmSlfQ.jpg"
},
() => {
let data = {
openid: this.local.openid
};
this.save(data);
},
function() {}
);
}
};



// WEBPACK FOOTER //
// ./src/pages/index.vue